import { render, staticRenderFns } from "./procesa-Imagen-participacion.vue?vue&type=template&id=79f78d9f&scoped=true"
import script from "./procesa-Imagen-participacion.vue?vue&type=script&lang=ts"
export * from "./procesa-Imagen-participacion.vue?vue&type=script&lang=ts"
import style0 from "./procesa-Imagen-participacion.vue?vue&type=style&index=0&id=79f78d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f78d9f",
  null
  
)

export default component.exports